'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SellPageLinks = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _GiftLink = require('./GiftLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellPageLinks = exports.SellPageLinks = function SellPageLinks() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/fitness' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.fitness',
          defaultMessage: 'Why studio fitness'
        })
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/explore' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.explore',
          defaultMessage: 'Explore studios'
        })
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/features' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.features',
          defaultMessage: 'How it works'
        })
      )
    ),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/pricing' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.pricing',
          defaultMessage: 'Pricing'
        })
      )
    ),
    _react2.default.createElement(_GiftLink.GiftLink, null),
    _react2.default.createElement(
      'li',
      null,
      _react2.default.createElement(
        'a',
        { href: '/blog', target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.link.blog',
          defaultMessage: 'Community'
        })
      )
    )
  );
};